import React, {Component} from 'react';
import './ProfileCard.css';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Avatar, OptionsButton} from '../widgets';
import {sessionActions} from '../user';
import confirmActions from '../widgets/confirmation.actions';
import {sessionUserIsIdentifiable} from '../user/session.selectors';

export const PresentationProfileCard = ({
	setFavourite,
	provider,
	favourites,
	size = 'small',
	screenSize,
	children,
	sessionProvider,
	options,
	recommendations,
	confirmUnfavourite,
	disabled = false,
	sessionUserIsIdentifiable
}) => {
	if (!provider.profile || !provider.user) return null;
	if (provider.subscriptionLevel === 'none') return null;

	return (
		<li
			className={`ProfileCard ${provider.premium ? 'ProfileCard-premium' : ''} ${
				size === 'small' ? 'small' : 'normal'
			} ${provider.available ? '' : 'unavailable'} ${options ? 'has-options' : ''}`}>
			<Link
				disabled={disabled}
				onClick={disabled ? e => e.preventDefault() : undefined}
				onMouseDown={disabled ? e => e.preventDefault() : undefined}
				to={`/@${provider.profile.uniqueName}`}
				style={{
					backgroundImage: provider.premium
						? `url("/api/image/${provider.profile.backgroundImage}")`
						: null,
					backgroundPosition: `center ${provider.backgroundPosition}%`
				}}>
				<div className="ProfileCard-splonk" />
				<SaveButton
					provider={provider}
					setFavourite={setFavourite}
					confirmUnfavourite={confirmUnfavourite}
					favourites={favourites}
					sessionProvider={sessionProvider}
					sessionUserIsIdentifiable={sessionUserIsIdentifiable}
				/>
				{options && <OptionsButton className="ProfileCard-options" options={options} />}

				<div className="ProfileCard-meta">
					<Avatar
						size={size === 'small' ? 64 : screenSize === 'mobile' ? 100 : 128}
						backgroundImage={provider.profile.avatarImage}
					/>
					{provider.avgRating && (
						<span className="ProfileCard-rating">
							{[1, 2, 3, 4, 5].map(num => (
								<span
									key={num}
									className={provider.avgRating >= num ? 'icon icon-star' : 'icon icon-star_border'}
								/>
							))}
						</span>
					)}
				</div>

				<div className="ProfileCard-bio">
					<h2>
						{provider.user.firstname} {provider.user.lastname}
					</h2>

					{provider.user.businessName ? (
						<div className="ProfileCard-businessName">{provider.user.businessName}</div>
					) : (
						undefined
					)}

					<div className="ProfileCard-profession">{provider.profession}</div>

					<div className="ProfileCard-location">
						<span className="icon-room" />
						<span>{provider.user.location.suburb}</span>
					</div>

					{recommendations && recommendations.length ? (
						<div className="ProfileCard-recommendations">
							<h3>Added by</h3>
							<ol>
								{recommendations.map(rec => (
									<Avatar key={rec.uuid} provider={rec} size={size === 'small' ? 24 : 32} />
								))}
							</ol>
						</div>
					) : (
						undefined
					)}

					{!provider.available && <div className="ProfileCard-availability">Unavailable</div>}
				</div>
			</Link>
			{children}
		</li>
	);
};

class SaveButton extends Component {
	constructor(props) {
		super(props);

		this.setFavourite = () => {
			const {setFavourite, provider, favourites} = this.props;

			setFavourite(provider.uuid, !(favourites && favourites[provider.uuid]));
		};

		this.onClick = e => {
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}

			const {provider, favourites, confirmUnfavourite} = this.props;

			const isFavourite = !!(favourites && favourites[provider.uuid]);

			if (isFavourite) {
				confirmUnfavourite(provider.user && provider.user.firstname, this.setFavourite);
			} else {
				this.setFavourite();
			}
		};

		const {provider, favourites} = props;
		this.wasFavouriteOnInit = !!(favourites && favourites[provider.uuid]);
	}

	render() {
		const {sessionProvider, provider, favourites, sessionUserIsIdentifiable} = this.props;

		if (!provider || !sessionProvider || !sessionProvider.user || !sessionUserIsIdentifiable) {
			return null;
		}

		const isFavourite = !!(favourites && favourites[provider.uuid]);

		// xor between mouseover|favourited
		const icon = isFavourite ? 'icon-favorite' : 'icon-favorite_border';

		return (
			<button
				className={`ProfileCard-save ${isFavourite ? 'saved' : ''} ${
					this.wasFavouriteOnInit ? 'init' : ''
				}`}
				onClick={this.onClick}
				title={
					isFavourite
						? 'In your "My providers"; click to remove'
						: 'Add this provider to your "My providers" collection'
				}>
				<span className={icon} />
				{provider.favouritedCount ? (
					<span className={'ProfileCard-save-count'}>{provider.favouritedCount}</span>
				) : (
					undefined
				)}
			</button>
		);
	}
}

const ConnectedProfileCard = connect(
	state => ({
		screenSize: state.ui.screenSize,
		sessionProvider: state.session && state.session.current,
		favourites: state.session && state.session.favourites,
		sessionUserIsIdentifiable: sessionUserIsIdentifiable(state)
	}),
	dispatch => ({
		setFavourite: (uuid, isFavourite) => dispatch(sessionActions.setFavourite(uuid, isFavourite)),
		confirmUnfavourite: (firstname, onConfirm) =>
			dispatch(
				confirmActions.open({
					title: `Remove ${firstname} from your "My providers"?`,
					message: `This will remove ${firstname} from your "My providers" list. You can re-add them later if you wish.`,
					onConfirm,
					data: 'unfavourite'
				})
			)
	})
)(PresentationProfileCard);

export default ConnectedProfileCard;



// WEBPACK FOOTER //
// ./src/profile/ProfileCard.js